import { render } from "./PlatformGovernanceFilter.vue?vue&type=template&id=10bab245&scoped=true"
import script from "./PlatformGovernanceFilter.vue?vue&type=script&lang=js"
export * from "./PlatformGovernanceFilter.vue?vue&type=script&lang=js"

import "./PlatformGovernanceFilter.vue?vue&type=style&index=0&id=10bab245&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bab245"]])

export default __exports__